import { defineStore } from "pinia";
import type { LoginRequest, LoginResponse, User, ProfileRequest, UserResponse, UpdateUsersResponse, UpdateUsersRequest,changePassReq,Status,changePinReq,changeTravelReq,InfoContactRes,Subaccount,createSubAccount,CreateSubRes,forgotPassword,SubAccountRes,deleteAccount,selfRegister } from "~/istypes";

export const useUserStore = defineStore('user', () => {
    const config = useRuntimeConfig();
    const airline = useAirlinesStore();
    const train = useTrainStore();
    const pelni = usePelniStore();
    const passenger = usePassengersStore()
    const user = ref();
    const currentSaldo = ref();
    const config_user = ref()
    const token = useCookie('XSRF-TOKEN', {
        maxAge: 60 * 60,
        secure: true,
        httpOnly: true,
        sameSite: 'strict',
    });

    const setToken = (data?: any) => (token.value = data);
    const setUser = (data?: any) => (user.value = data);
    const setConfigUser = (data?: any) => (config_user.value = data);

    const generateRandomId = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let randomId = '';
        for (let i = 0; i < 16; i++) {
            randomId += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return randomId;
    };

    const deviceId = () => {
        const savedDeviceId = localStorage.getItem('deviceId');
        if(savedDeviceId){
            return savedDeviceId;
        }else{
            const newDeviceId = generateRandomId();
            localStorage.setItem('deviceId', newDeviceId);
            return newDeviceId;
        }
    }

    const signIn = async (data: LoginRequest) => {
        try {
            const res = await $fetch<LoginResponse>(`${config.public.ApiBase}/get_access`, {
                method: "POST",
                body: data,
                headers:{
                    "Device-Id": deviceId(),
                }
            });

            if (res.status?.code == 200) {
                setToken(res.details.token?.access_token);
                setUser(res.details.user)
                setConfigUser(res.details.config_user)
            }

            return res;

        } catch (error) {
            setToken();
            setUser();
            console.log(error);
        }
    };

    const saveToLocalStorage = (key: string, data: any) => {
        localStorage.setItem(key, JSON.stringify(data));
    };

    const getAirportDom = async() => {
        try {
            const response = await airline.getDomesticAirport()
            return response;
        } catch (error) {
            return error
        }
    }

    const getAirportInt = async() => {
        try {
            const response = await airline.getInternationalAirport()
            return response;
        } catch (error) {
            return error
        }
    }


    const getStation = async() => {
        try {
            const response = await train.getStations();
            return response;
        } catch (error) {
            return error
        }
    }

    const getHarbour = async() =>{
        try {
            const response = await pelni.getPelabuhan();
            return response;
        } catch (error) {
            return error
        }
    }

    const getPassengers = async() => {
        try {
            const response = await passenger.getPassengers();
            return response
        } catch (error) {
            return error
        }
    }

    const getInfoContact = async() => {
        try{
            const headers: Record<string, string> = {};
        
            headers["Device-Id"] = deviceId();

            if (token.value) {
                headers.Authorization = `Bearer ${token.value}`;
            }
            const res = await $fetch<InfoContactRes>(`${config.public.ApiBase}/supports/contact_us`, {
                method: "POST",
                headers
            })

            return res
        }catch(error){
            return error
        }
    }

    const submitOTP = async (data: LoginRequest) => {
        try {
            const res = await $fetch<LoginResponse>(`${config.public.ApiBase}/get_access`, {
                method: "POST",
                body: data,
                headers:{
                    "Device-Id": deviceId(),
                }
            });

            if (res.status?.code == 200) {
                console.log('token',token.value)
                setToken(res.details.token?.access_token);
                setUser(res.details.user)
                setConfigUser(res.details.config_user)
                
                const domAirports = await getAirportDom();
                const intAirports = await getAirportInt();
                const stations = await getStation();
                const harbours = await getHarbour();
                const passengers = await getPassengers();
                const airlinesCode = await airline.getAirlinesCode();
                const contact = await getInfoContact();


                // Store the results in local storage
                saveToLocalStorage('domesticAirports', domAirports);
                saveToLocalStorage('internationalAirports', intAirports);
                saveToLocalStorage('stations', stations);
                saveToLocalStorage('passengers',passengers);
                saveToLocalStorage('harbours', harbours);
                saveToLocalStorage('airlines_code', airlinesCode);
                saveToLocalStorage('addreses', contact)
                }

            return res;
        } catch (error) {
            token.value = undefined;
            setUser();
            console.log(error);
        }
    };

    const fetchUser = async (data: ProfileRequest) => {
        if (token.value) {
            try {
                const res = await $fetch<UserResponse>(`${config.public.ApiBase}/profiles`, {
                    method: "POST",
                    body: data,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                if (res.status?.code == 200) {
                    setUser(res.details?.user);
                    // setConfigUser(res.details?.config_user)
                }

                return res;
            } catch (error) {
                setUser();
                console.log(error);
            }
        }
    };

    const fetchUserBalance =  async () => {
        if (token.value) {
            try {
                const res = await $fetch<UserResponse>(`${config.public.ApiBase}/deposits/balance`, {
                    method: "POST",
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                if (res.status?.code == 200) {
                    currentSaldo.value = res.details?.deposit;
                }

                return res;
            } catch (error) {
                currentSaldo.value = '';
                console.log(error);
            }
        }
    }

    const updateUserProfile = async (data: User) => {
        if (token.value) {
            try {
                const res = await $fetch<UpdateUsersResponse>(`${config.public.ApiBase}/profiles/update_user`, {
                    method: 'POST',
                    body: data,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                });
                console.log("User Update: ", res);


                if (res.status?.code == 200) {
                    // setUser(res.details);
                }

                return res;
            } catch (error) {
                console.error('Error updating profile:', error);
            }
        }
    };


    const getProvince = async () => {
        try {
            const response = await $fetch(`${config.public.ApiRest}location/provinces`, {
                method: "GET",
            });

            return response;
        } catch (error) {
            console.error("Error fetching:", error);
        }
    };

    const getCities = async (provinceId: any) => {
        try {
            const response = await $fetch(`${config.public.ApiRest}location/cities?province_id=${provinceId}`, {
                method: "GET"
            });

            return response;
        } catch (error) {
            console.error("Error fetching:", error);
        }
    };

    const getSubdistricts = async (cityId: any) => {
        try {
            const response = await $fetch(`${config.public.ApiRest}location/subdistricts?city_id=${cityId}`, {
                method: "GET"
            });

            return response;
        } catch (error) {
            console.error("Error fetching:", error);
        }
    };


    const updateProfile = async(photo : File | Blob) => {
        if (token.value) {
            try {
                const formData = new FormData();
                formData.append('photo', photo as Blob);
                const response = await $fetch<Status>(`${config.public.ApiBase}/profiles/upload_photo`,{
                    method: 'POST',
                    body: formData,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                })

                return response
            } catch (error) {
                return error;
            }
        }
    }


    const updateTravelLogo = async(logo: File | Blob) => {
        if(token.value){
            try {
                const formData = new FormData();
                formData.append('logo', logo as Blob);
                const response = await $fetch<Status>(`${config.public.ApiBase}/profiles/upload_logo`,{
                    method: 'POST',
                    body: formData,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                })

                return response
            } catch (error) {
                return error;
            }
        }
    }


    const resetPassword = async(data: changePassReq) => {
        if (token.value) {
            try {
                const response = await $fetch<Status>(`${config.public.ApiBase}/users/reset_password`,{
                    method: 'POST',
                    body: data,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                })
                return response;
            } catch (error) {
                return error;
            }
        }
    }

    const changePin = async(data: changePinReq) => {
        if (token.value) {
            try {
                const response = await $fetch<Status>(`${config.public.ApiBase}/users/change_pin`,{
                    method: 'POST',
                    body: data,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                })
                return response;
            } catch (error) {
                return error;
            }
        }
    }

    const changePhone = (data: any) => {
        if (token.value) {
            try {
                const response = $fetch<Status>(`${config.public.ApiBase}/users/change_phone`,{
                    method: 'POST',
                    body: data,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                })

                return response;
            }catch (error) {
                return error
            }
        }
    }

    const resetPin = (data: any) => {
        if (token.value) {
            try {
                const response = $fetch<Status>(`${config.public.ApiBase}/users/reset_pin`,{
                    method: 'POST',
                    body: data,
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                })

                return response;
            }catch (error) {
                return error
            }
        }
    }

    const logout = async () => {
        try {
            const response = await $fetch<any>(`${config.public.ApiBase}/logout`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                    Authorization: `Bearer ${token.value}`,
                },
            })

            if (response.status.code == 200) {
                setToken(null);
                setUser(null);
                setConfigUser(null);
            }

            return response;
        } catch (error) {
            return error
        }
    };

    const updateTravel = async (data: changeTravelReq) => {
        if(token.value){
            try {
                const response = await $fetch<Status>(`${config.public.ApiBase}/profiles/update_travel`,{
                    method: 'POST',
                    headers: {
                         "Device-Id": deviceId(),
                        Authorization: `Bearer ${token.value}`,
                    },
                    body: data
                })
                return response;
            } catch (error) {
                return error;
            }
        }
    };

    const getSubAccount = async () => {
        try {
            const response = await $fetch<SubAccountRes>(`${config.public.ApiBase}/users/sub_account`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                    Authorization: `Bearer ${token.value}`,
                },
            });

            return response
        } catch (error) {
            return error
        }
    }

    const createSubAccount = async(data: createSubAccount) => {
        try {
            const response = await $fetch<CreateSubRes>(`${config.public.ApiBase}/users/sub_account/registration`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                    Authorization: `Bearer ${token.value}`,
                },
                body: data
            })
            return response
        } catch (error) {
            return error
        }
    }

    const selfRegisterSubAccount = async(data: selfRegister) => {
        try {
            const response = await $fetch<any>(`${config.public.ApiBase}/users/sub_account/self_registration`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                },
                body: data
            })
            return response
        } catch (error) {
            return error
        }
    }

    const detailSubAccount = async(id: number) => {
        try {
            const response = await $fetch<CreateSubRes>(`${config.public.ApiBase}/users/sub_account/detail`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                    Authorization: `Bearer ${token.value}`,
                },
                body: {
                    subaccount_id: id
                }
            })
            return response
        } catch (error) {
            return error
        }
    }

    const updateSubAccount = async(data: createSubAccount) => {
        try {
            const response = await $fetch<any>(`${config.public.ApiBase}/users/sub_account/update`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                    Authorization: `Bearer ${token.value}`,
                },
                body: data
            })
            return response
        } catch (error) {
            return error
        }
    } 

    const lockSubAccount = async(id: number) => {
        try {
            const response = await $fetch<CreateSubRes>(`${config.public.ApiBase}/users/sub_account/lock`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                    Authorization: `Bearer ${token.value}`,
                },
                body: {
                    subaccount_id: id
                }
            })
            return response
        } catch (error) {
            return error
        }
    }

    const unLockSubAccount = async(id: number) => {
        try {
            const response = await $fetch<CreateSubRes>(`${config.public.ApiBase}/users/sub_account/unlock`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                    Authorization: `Bearer ${token.value}`,
                },
                body: {
                    subaccount_id: id
                }
            })

            return response
        } catch (error) {
            return error
        }
    }

    const forgotPassword = async(data: forgotPassword) => {
        try {
            const response = await $fetch<Status>(`${config.public.ApiBase}/forget_password`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                },
                body: data
            })
            return response
        } catch (error) {
            return error
        }
    }

    const deleteAccount = async(data: deleteAccount) => {
        if(token.value){
            try{
                const response = await $fetch<Status>(`${config.public.ApiBase}/users/delete_account`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token.value}`,
                        "Device-Id": deviceId(),
                    },
                    body: data
                })

                return response;
            }catch(error){
                return error
            }
        }
    }

    const checkPin = async () => {
        try {
            const response = await $fetch<any>(`${config.public.ApiBase}/home`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token.value}`,
                    "Device-Id": deviceId(),
                },
            })

            return response;
        } catch (error) {
            return error
        }
    }
    
    const setPin = async (pin: string, confirmPin: string) => {
        try {
            const response = await $fetch<any>(`${config.public.ApiBase}/users/set_pin`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token.value}`,
                    "Device-Id": deviceId(),
                },
                body: {
                    pin: pin,
                    confirm_pin: confirmPin
                }
            })

            return response;
        } catch (error) {
            return error
        }
    }

    const verifyTokenClient = async(token: string,id: any) => {
        try {
            const response = await $fetch<any>(`${config.public.ApiBase}/kisel/verify_token`, {
                method: "POST",
                headers: {
                    "Device-Id": deviceId(),
                },
                body: {
                    id: id,
                    client_token: token
                }
            })

            return response;
        } catch (error) {
            return error
        }
    }

    const getUplineDetail = async(ref: string) => {
        try{
            const response = await $fetch<any>(`${config.public.ApiRest}referal/${ref}`, {
                method: "GET",
                headers: {
                    "Device-Id": deviceId(),
                },
            })

            return response;
        }catch(error){
            return error
        }
    }
    return { user, token, currentSaldo,config_user, logout, signIn, submitOTP, fetchUser, setUser, updateUserProfile, getProvince, getCities, 
        getSubdistricts,deviceId,generateRandomId,updateProfile,updateTravelLogo,resetPassword,changePin,updateTravel,
        getInfoContact,getSubAccount,createSubAccount,forgotPassword,detailSubAccount,updateSubAccount,lockSubAccount,unLockSubAccount,changePhone,
        resetPin,deleteAccount,saveToLocalStorage,checkPin,setPin,fetchUserBalance,verifyTokenClient,selfRegisterSubAccount,getUplineDetail };
},{
    persist: {
        paths: ['token', 'user', 'currentSaldo','config_user'],
    }
});
